import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type { ParentDetails } from '../model/parent.type';

// Type for partial parent updates - all fields are optional
export type PartialParentUpdate = Partial<ParentDetails>;

export interface UpdateParentByStudentIdParams {
  studentId: string;
  parentId: string;
  parent: PartialParentUpdate;
}

export const parentDetailsUpdatePath = (studentId: string, parentId: string) =>
  studentId
    ? `studios/update/parent/all-details/${studentId}`
    : `parents/${parentId}`;

export const updateParentByParentIdAPI = async (
  studentId: string,
  parentId: string,
  parent: PartialParentUpdate,
) => {
  const response = await baseAPI.patch<ParentDetails>(
    parentDetailsUpdatePath(studentId, parentId),
    parent,
  );
  return response.data;
};

export const useUpdateParentByStudentId = () => {
  return useMutation({
    mutationFn: (params: UpdateParentByStudentIdParams) =>
      updateParentByParentIdAPI(
        params.studentId,
        params.parentId,
        params.parent,
      ),

    onSuccess: (_, params) => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.PARENT, params.studentId],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.PARENT, params.parentId],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.FAMILY_HUB],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.FAMILY_BY_STUDENT],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.FAMILY_BY_PARENT],
      });
    },
  });
};
